import { Routes } from '@angular/router';
import {
  AuthPageComponent,
  CheckoutPageComponent,
  ContactPageComponent,
  FrontPageComponent,
  OrderPageComponent,
  SuccessPageComponent,
  PdfViewerPageComponent
} from '@oneqrew-partnertool/pages';
import { ConfirmExit, CustomerResolver, InitailPlansResolver, PageGuard, PlanResolver } from '@oneqrew-partnertool/utils';

export const appRoutes: Routes = [
  { path: 'umstellung', component: AuthPageComponent, data: { isSubPage: false } },
  {
    path: 'umstellung/contact/:id',
    component: ContactPageComponent,
    canActivate: [PageGuard],
    data: { isSubPage: true }
  },
  {
    path: 'umstellung/order/:id',
    component: OrderPageComponent,
    canActivate: [PageGuard],
    data: { isSubPage: true, isReloadablePage: true },
    resolve: { plans: InitailPlansResolver },
    title: 'Umstellung shp - Kunden- und Bestellinformationen'
  },
  {
    path: 'umstellung/checkout/:id',
    component: CheckoutPageComponent,
    canActivate: [PageGuard],
    data: { isSubPage: true },
    title: 'Umstellung shp - Bezahlinformationen'
  },
  {
    path: 'umstellung/success/:id',
    component: SuccessPageComponent,
    canDeactivate: [ConfirmExit],
    canActivate: [PageGuard],
    data: { isSubPage: false },
    title: 'Umstellung shp - Erfolgreich bestellt'
  },
  {
    path: 'pdf/:id/:filename',
    component: PdfViewerPageComponent,
    data: {
      isReloadablePage: true
    },
    title: 'Umstellung shp - AVV Entwurf'
  },
  {
    path: 'umstellung/:id',
    component: FrontPageComponent,
    data: { isSubPage: false, isReloadablePage: true },
    resolve: {
      plans: InitailPlansResolver,
      plan: PlanResolver,
      customer: CustomerResolver
    },
    canActivate: [PageGuard],
    title: 'Umstellung shp - Abo-Vergleich'
  },
  { path: '**', redirectTo: '/umstellung', pathMatch: 'full' }
];
